<template>
  <div class="f-60">
    <div class="alive_content">
      <div class="title f-center-title">
        如然空调，越用越懂你
        <div class="desc_text f-center-sub-title">
          将如然空调与经典空调有机融合；每 7
          天迭代一次你的使用习惯，持续逼近你的黄金体感，
          <div>智能调节温度、风量、内外循环、除霜除雾、座椅舒适性等操作</div>
        </div>
      </div>
      <m-video
        ref="video"
        muted
        disablepictureinpicture
        playsinline
        webkit-playsinline
        src="@/v2/auto/assets/video/60/0.mp4"
      />
      <replay class="replay" @click="replayVideo($refs.video)" />
    </div>
  </div>
</template>

<script>
import { videoPlayByVisibleArea, replayVideo } from '@/utils'
import replay from '@/components/replay.vue'

export default {
  name: 'Assistant',
  components: {
    replay,
  },
  data() {
    return {
      preload_: true,
    }
  },
  mounted() {
    videoPlayByVisibleArea(this.$refs.video)
  },
  methods: {
    replayVideo,
  },
}
</script>

<style lang="less" scoped>
.f-60 {
  width: 100%;
  background-color: #000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

// Content section
.alive_content {
  position: relative;
  width: 100%;
  margin-top: 200px;
  background: #000000;
  .title {
    position: absolute;
    flex-direction: column;
    width: 100%;
    font-weight: 700;
    display: flex;
    text-align: center;
    background: radial-gradient(
      131.96% 70.14% at 50% 18.06%,
      #eadaff 0%,
      #ffffff 100%
    );
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
    .desc_text {
      margin-top: 20px;
      color: #ffffff;
      text-align: center;
      line-height: 1.6;
      font-weight: 300;
    }
  }

  video {
    width: 100%;
    object-fit: cover;
  }

  // Replay button
  .replay {
    position: absolute;
    bottom: 0;
    right: 18%;
    z-index: 1;
    color: white;
  }
}
</style>
